const discount = {
  props: {
    cssSelector: "c-fastbooking__submenu-discount",
    classNameDiscount: "enable",
    promocodeSelector: "promocode-JS",
    deletePromocodeJS: ".delete-promocode-JS",
    formPromoCodeJS: ".form-promocode-JS",
    tabSelector: "discount-JS",
    checkboxSelector: "discounts-checkbox-JS",
    attrPromocode: "promocode",
    attrCampaignPromo: "promo",
    cookieName: "barcelo_FB_discount",
    noActiveSelector: "promocode-noactive-JS",
    activeSelector: "promocode-active-JS",
    isDiscountInput: false,
  },

  init: function () {
    if (bcl.c.fastbooking.disabled) {
      delete bcl.c.fastbooking.discount;
      return;
    }

    const $container = bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.cssSelector);

    if (!$container?.[0]) {
      return;
    }

    this.props.$container = $container[0];

    this.initNodes();

    this.initPromocode();
    this.initCheckbox();

    this.getInitCookies();
    this.parseQueryParams();
  },
  initNodes: function () {
    const $container = bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.tabSelector);

    if (!$container?.[0]) {
      return;
    }

    this.props.$tab = $container[0];
  },

  initPromocode: function () {
    const $container = this.props.$container.getElementsByClassName(this.props.promocodeSelector);

    if (!$container?.[0]) {
      return;
    }

    const $input = $container[0].children[0];
    this.props.$inputPromocode = $input;

    $input.addEventListener("keypress", function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    if ($container[0].children[2]) {
      $container[0].children[2].addEventListener("click", () => {
        this.addOrRemovePromocode($input.value);

        bcl.s.tabs.closeActive();
      });
    } else {
      $input.setAttribute("value", "");
      $input.value = "";
      this.addOrRemovePromocode("");
    }
  },

  hiddeShowActiveElements: function (method) {
    bcl.u[method](bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.activeSelector));
    bcl.u[method](bcl.c.fastbooking.commonProps.fastbooking.$container.querySelectorAll(this.props.formPromoCodeJS));
    const methodToNoActive = method === "showElements" ? "hiddeElements" : "showElements";
    bcl.u[methodToNoActive](bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.noActiveSelector));
  },

  addOrRemovePromocode: function (value) {
    const key = this.props.attrPromocode;

    if (value) {
      bcl.u.hiddeElements(bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.noActiveSelector));
      bcl.u.showElements(bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.activeSelector));
      bcl.u.hiddeElements(bcl.c.fastbooking.commonProps.fastbooking.$container.querySelectorAll(this.props.formPromoCodeJS));
      this.add(value, key, value);
    } else {
      bcl.u.showElements(bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.noActiveSelector));
      bcl.u.hiddeElements(bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.activeSelector));
      bcl.u.hiddeElements(bcl.c.fastbooking.commonProps.fastbooking.$container.querySelectorAll(this.props.formPromoCodeJS));
      this.remove(key);
    }
  },

  initCheckbox: function () {
    const $container = bcl.c.fastbooking.commonProps.fastbooking.$container.getElementsByClassName(this.props.checkboxSelector);

    if (!$container?.[0]) {
      return;
    }

    this.props.$containerCheckbox = $container[0];

    const inputs = this.props.$containerCheckbox.querySelectorAll("input");

    bcl.u.forEach(inputs, ($input, index) => {
      $input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          this.click();
        }
      });
      $input.addEventListener("change", () => {
        this.props.isDiscountInput = true;
        this.addOrRemoveCheckbox($input, index);
      });
    });
  },

  cleanCheckbox: function () {
    const inputs = this.props.$containerCheckbox.querySelectorAll("input");
    bcl.u.forEach(inputs, ($input, index) => {
      $input.checked = false;
      this.props.isDiscountInput = true;
      this.addOrRemoveCheckbox($input, index);
    });
  },

  addOrRemoveCheckbox: function ($input, key) {
    const checked = $input.checked,
      value = $input.dataset.value,
      $label = $input.parentNode.children[1];

    if (this.props.$containerCheckbox) {
      const allInputs = this.props.$containerCheckbox.querySelectorAll("input");
      checked && this.selectOnlyOneOption(value, allInputs);
    }

    if (checked) {
      this.add(value, key, $label.innerText);
      this.addCookies();
    } else {
      this.remove(key);
    }
  },

  selectOnlyOneOption: function (currentValue, allElements) {
    for (let i = 0; i < allElements.length; i++) {
      if (allElements[i].dataset.value !== currentValue) {
        allElements[i].checked = false;
        delete bcl.c.fastbooking.commonProps.discount.data[i];
      }
    }
  },

  add: function (value, key, label, selector) {
    bcl.c.fastbooking.commonProps.discount.data[key] = {
      value: value,
      label: label,
      selector: selector,
    };

    this.update();
  },

  remove: function (key) {
    delete bcl.c.fastbooking.commonProps.discount.data[key];

    this.update();
  },

  update: function () {
    if (!this.props.$tab) {
      return;
    }

    let arrays = Object.keys(bcl.c.fastbooking.commonProps.discount.data);
    if (bcl.u.containsClass(document.body, "homepage") && !this.props.isDiscountInput) {
      arrays = bcl.c.fastbooking.deleteAllOtherValueInArray(arrays, "promocode");
    }

    this.props.isDiscountInput = false;

    const length = arrays.length,
      $node = this.props.$tab.children[1];

    this.hiddeShowActiveElements("hiddeElements");

    if (length > 0) {
      bcl.u.addClass(this.props.$tab, this.props.classNameDiscount);
      bcl.u.removeClass($node, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
      this.hiddeShowActiveElements("showElements");

      if (length == 1) {
        $node.innerText = bcl.c.fastbooking.commonProps.fastbooking.$container.dataset.i18nOnediscount;
      } else if (length == 2) {
        $node.innerText = bcl.c.fastbooking.commonProps.fastbooking.$container.dataset.i18nTwodiscount;
      } else if (length == 3) {
        $node.innerText = bcl.c.fastbooking.commonProps.fastbooking.$container.dataset.i18nThreediscount;
      } else {
        $node.innerText = bcl.c.fastbooking.commonProps.fastbooking.$container.dataset.i18nMorediscount;
      }
      return;
    } else {
      bcl.u.removeClass(this.props.$tab, this.props.classNameDiscount);
    }

    bcl.u.addClass($node, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
  },

  addPromocode: function (value, isOpen) {
    this.props.$inputPromocode.value = value;
    this.addOrRemovePromocode(value);

    this.addCookiesOnlyPromocode();

    isOpen && bcl.c.fastbooking.afterSetData();
  },

  getMappedCoupon: function (inputValue) {
    if (!inputValue) {
      return null;
    }

    const CouponMap = Object.freeze({
      RESIDENT: "CRESIDENT",
      SENIOR: "SENIORB",
      MILLENNIAL: "AMILLENNIAL",
      ARMY: "ARMYB",
      FAMILY: "FAMILYB",
    });

    if (Array.isArray(inputValue)) {
      return inputValue.map((item) => this.getMappedCoupon(item));
    }

    const upperInput = inputValue.toUpperCase();
    const keys = Object.keys(CouponMap);
    const foundKey = keys.find((key) => upperInput.startsWith(key));

    if (foundKey) {
      const mappedValue = CouponMap[foundKey];
      const suffix = inputValue.substring(foundKey.length);
      return mappedValue + suffix;
    }

    return inputValue;
  },

  generateData: function (obj) {
    if (!bcl.c.fastbooking.commonProps.discount.data) {
      return;
    }

    if (bcl.c.fastbooking.commonProps.discount.data.promocode) {
      bcl.c.fastbooking.addCoupon(obj.coupon, bcl.c.fastbooking.commonProps.discount.data.promocode.value);
    }

    bcl.c.fastbooking.commonProps.discount.data.promo && bcl.c.fastbooking.addCoupon(obj.promo, bcl.c.fastbooking.commonProps.discount.data.promo.value);

    for (const key in bcl.c.fastbooking.commonProps.discount.data) {
      if (key !== this.props.attrPromocode && key !== this.props.attrCampaignPromo) {
        bcl.c.fastbooking.addCoupon(obj.coupon, bcl.c.fastbooking.commonProps.discount.data[key].value);
      }
    }
  },

  updateData: function (obj) {
    if (this.props.$inputPromocode) {
      this.props.$inputPromocode.value = obj.promocode?.value || "";
      this.addOrRemovePromocode(this.props.$inputPromocode.value);
    }

    const inputs = this.props.$container.querySelectorAll('[type="checkbox"]');

    bcl.u.forEach(inputs, ($input, index) => {
      const value = obj[index]?.value;

      $input.checked = this.foundDiscountsInHotel(value, $input);

      this.addOrRemoveCheckbox($input, index);
    });
  },

  foundDiscountsInHotel: function (value, $inputDiscount) {
    const $button = document.querySelector(".hotel-button-JS");
    let checked = false;

    if ($button?.dataset.specialdiscount?.includes(value) || (!$button && value === $inputDiscount.dataset.value)) {
      checked = true;
    }

    return checked;
  },

  getInitCookies: function () {
    let discounts = bcl.cookie.get(this.props.cookieName);

    if (!discounts) {
      return;
    }

    discounts = JSON.parse(discounts);

    if (!discounts) {
      return;
    }

    this.updateData(discounts);
  },

  addCookies: function () {
    const obj = bcl.c.fastbooking.commonProps.discount.data;

    bcl.c.fastbooking.calendar.removeCookie(this.props.cookieName);

    if (Object.keys(obj).length == 0) {
      return;
    }

    bcl.c.fastbooking.setCookies(this.props.cookieName, JSON.stringify(obj));
  },

  addCookiesOnlyPromocode: function () {
    let discounts = bcl.cookie.get(this.props.cookieName);

    if (discounts) {
      discounts = JSON.parse(discounts);
    } else {
      discounts = {};
    }

    discounts.promocode = bcl.c.fastbooking.commonProps.discount.data.promocode;

    bcl.c.fastbooking.setCookies(this.props.cookieName, JSON.stringify(discounts));
  },

  parseQueryParams: function () {
    let values = window.location.search;

    if (!values) {
      return;
    }

    values = decodeURIComponent(values);
    values = values.substring(1, values.length).split("&");

    for (const element of values) {
      const item = element.split("="),
        key = item[0],
        value = item[1];

      if ((key == "coupon" || key == "codes") && value) {
        this.addPromocode(value);
        break;
      }
    }
  },

  updateDataDest: function (data) {
    let specialDiscounts = null;

    if (data && data.type != "group" && data.data) {
      specialDiscounts = {};

      if (data.data.specialDiscounts) {
        for (const property in data.data.specialDiscounts) {
          if (Object.prototype.hasOwnProperty.call(data.data.specialDiscounts, property)) {
            specialDiscounts[property] = true;
          }
        }
      } else {
        bcl.u.addClass(this.props.$containerCheckbox, "hidden");
        return;
      }
    } else if (this.props.$containerCheckbox.dataset.activechecks === "false") {
      bcl.u.addClass(this.props.$containerCheckbox, "hidden");
      return;
    }

    const $inputs = this.props.$containerCheckbox.querySelectorAll("input");

    bcl.u.forEach($inputs, ($input) => {
      this.updateCheckboxDiscount($input, specialDiscounts);
    });

    bcl.u.removeClass(this.props.$containerCheckbox, "hidden");
  },

  updateCheckboxDiscount: function ($input, specialDiscounts) {
    let method = "addClass";
    if (specialDiscounts?.[$input.dataset.value] || (!specialDiscounts && $input.dataset.default === "true")) {
      method = "removeClass";
    }

    bcl.u[method]($input.parentNode, "hidden");
  },

  openTab: function ($container) {
    const $target = $container || this.props.$container;
    if (!$target) {
      return;
    }
    this.initDiscountFocusTrap($target);
    setTimeout(() => {
      const $firstFocusable = $target.querySelector(".close-JS:not([aria-hidden='true'])") || $target.querySelector("input:not([type='hidden']):not([disabled]), button, [role='button'], [tabindex]:not([tabindex='-1'])");
      if ($firstFocusable && typeof $firstFocusable.focus === "function") {
        // Safari does not apply :focus-visible to programmatic focus, so mark
        // the element to show the focus ring (see `.js-kbd-focus` in
        // accesibility.less). The marker removes itself on blur.
        if ($firstFocusable.classList) {
          $firstFocusable.classList.add("js-kbd-focus");
          $firstFocusable.addEventListener("blur", () => $firstFocusable.classList.remove("js-kbd-focus"), { once: true });
        }
        $firstFocusable.focus();
      }
    }, 50);
  },

  closeTab: function ($container) {
    const $target = $container || this.props.$container;
    this.removeDiscountFocusTrap($target);
    // Focus returns to the discount activator (handled by the tabs system).
    // Safari does not apply :focus-visible to programmatic focus, so mark the
    // activator to show the focus ring (see `.js-kbd-focus` in
    // accesibility.less). The marker removes itself on blur.
    const $activator = this.props.$tab;
    if ($activator && $activator.classList) {
      $activator.classList.add("js-kbd-focus");
      $activator.addEventListener("blur", () => $activator.classList.remove("js-kbd-focus"), { once: true });
    }
  },

  initDiscountFocusTrap: function ($target) {
    if (!$target || this.props.discountFocusTrapHandler) {
      return;
    }
    const handler = (event) => {
      if (event.key !== "Tab") {
        return;
      }
      const focusables = bcl.ariaUtils?.getFocusableElements?.($target) || [];
      if (focusables.length === 0) {
        return;
      }
      event.preventDefault();
      const currentIdx = focusables.indexOf(document.activeElement);
      let nextIdx;
      if (event.shiftKey) {
        nextIdx = currentIdx <= 0 ? focusables.length - 1 : currentIdx - 1;
      } else {
        nextIdx = currentIdx === -1 || currentIdx === focusables.length - 1 ? 0 : currentIdx + 1;
      }
      const next = focusables[nextIdx];
      if (next && typeof next.focus === "function") {
        // Safari does not apply :focus-visible to programmatic focus, so mark
        // the element to show the focus ring (see `.js-kbd-focus` in
        // accesibility.less). The marker removes itself on blur.
        if (next.classList) {
          next.classList.add("js-kbd-focus");
          next.addEventListener("blur", () => next.classList.remove("js-kbd-focus"), { once: true });
        }
        next.focus();
      }
    };
    this.props.discountFocusTrapHandler = handler;
    $target.addEventListener("keydown", handler);
  },

  removeDiscountFocusTrap: function ($target) {
    if (!this.props.discountFocusTrapHandler || !$target) {
      return;
    }
    $target.removeEventListener("keydown", this.props.discountFocusTrapHandler);
    this.props.discountFocusTrapHandler = null;
  },
};

export default discount;
